/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconFlagSolid = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 22 25"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 25px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M.75 1.25v23" />
        <path
          fill="currentColor"
          d="M.75 1.25H20.5a.75.75 0 0 1 .56 1.248L17.055 7a1.5 1.5 0 0 0 0 1.994l4 4.505a.75.75 0 0 1-.56 1.248H.75V1.25z"
        />
      </g>
    </svg>
  ),
);
